import type { Values } from "nuqs";
import type { marketplaceSearchParamsParser } from "./marketplace-search-params";

const FILTER_PARAM_KEYS = [
  "compensation",
  "compensation_rate",
  "category",
  "work_model",
  "commitment",
  "priority",
  "resume",
  "posted_date",
] as const;

type MarketplaceSearchParams = Values<typeof marketplaceSearchParamsParser>;

export function countActiveMarketplaceFilters(
  searchParams: MarketplaceSearchParams
) {
  let count = 0;
  for (const key of FILTER_PARAM_KEYS) {
    const value = searchParams[key];
    if (value === null || value === undefined) {
      continue;
    }
    if (Array.isArray(value) && value.length === 0) {
      continue;
    }
    count += 1;
  }
  return count;
}

export function hasActiveMarketplaceFilters(
  searchParams: MarketplaceSearchParams
) {
  return countActiveMarketplaceFilters(searchParams) > 0;
}
